import { useDispatch } from 'react-redux';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { actions } from 'src/redux/productImagesCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';
import type { NextConfig } from 'src/types/nextConfig';
import type { ProductImagesCarouselDispatchProps } from './ProductImagesCarousel';

export const useProductImagesCarouselActions = (): ProductImagesCarouselDispatchProps => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const nextConfig = getConfig() as NextConfig;

  return {
    onFavouriteClick: (productCode) => dispatch(updateFavourite({ productCode, nextConfig })),
    onNextImage: (payload) => dispatch(actions.nextImage(payload)),
    onOpenModal: (payload) => dispatch(actions.openModal(payload)),
    onPrevImage: (payload) => dispatch(actions.prevImage(payload)),
    setCurrentImage: (payload) => dispatch(actions.setCurrentImage(payload)),
  };
};
